export const ORDER_STATUSES_WITH_PENDING_STOCK = [
  'pending',
  'processing',
  'partially_prepared',
  'partially_served',
];

export const CANCELLED_ORDER_STATUSES = [
  'cancelled',
  'partially_served_cancelled',
];

export const isOrderStatusWithPendingStock = (status) =>
  ORDER_STATUSES_WITH_PENDING_STOCK.includes(status);

export const isCancelledOrderStatus = (status) =>
  CANCELLED_ORDER_STATUSES.includes(status);
